<template>
  <div class="main" id="brand-detail">
    <div class="scroll-nav-wraper">
      <v-affix class="fixed" relative-element-selector="#brand-detail" :offset="{ top: 218, bottom: 0 }"
        :scroll-affix="false">
        <scroll-active class="scroll-nav" highlight-first-item tag="ul" :offset="0">
          <li class="scroll-nav-item scrollactive-item" data-section-selector=".introduction"
            v-if="company_introduce.length">
            品牌介绍
          </li>
          <template v-for="(item, nn) in company_introduce">
            <li class="scroll-nav-item scrollactive-item" :data-section-selector="`.brand0${nn}`">
              {{ item.name }}
            </li>
          </template>
        </scroll-active>
      </v-affix>
    </div>
    <div class="brand-content">
      <div key="introduction" class="brand-content__item introduction">
        <div class="brand-introduction">
          <em></em>
          <span>船舶公司介绍</span>
        </div>
        <el-image :src="cruiseData.logo" class="brand-company__logo"></el-image>
        <div class="brand-company__name">{{ cruiseData.name }}</div>
        <div class="brand-company__describe">{{ cruiseData.describe }}</div>
        <el-image v-if="cruiseData.cover" :src="cruiseData.cover" class="brand-image" fit="cover"></el-image>
        <div class="brand-video" v-if="!!cruiseData.video && !!cruiseData.video_cover">
          <VPlayer :src="cruiseData.video" :cover="cruiseData.video_cover"></VPlayer>
        </div>
        <p>{{ cruiseData.introduction }}</p>
      </div>
      <div v-for="(item, nn) in company_introduce" :key="`item0${nn}`" class="brand-content__item"
        :class="`brand0${nn}`">
        <div class="brand-content__title">
          <em></em>
          <span>{{ item.title }}</span>
        </div>
        <template v-for="(child, childIndex) in item.introduce">
          <p v-if="child.attribute_type === '1'">{{ child.content }}</p>
          <el-image v-if="child.attribute_type === '2'" :src="child.url" class="brand-image" fit="cover"></el-image>
          <div class="brand-video" v-if="child.attribute_type === '3'">
            <VPlayer :src="child.url"></VPlayer>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import ScrollActive from "@/components/ScrollActive";
import VAffix from "@/components/VAffix";
import VPlayer from "@/components/VPlayer/index.vue";

// helpers
import { defineComponent } from "@nuxtjs/composition-api";

export default defineComponent({
  components: { ScrollActive, VAffix, VPlayer },
  props: {
    cruiseData: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      company_introduce: []
    }
  },
  mounted() {
    this.company_introduce = this.cruiseData.company_introduce;
  }
});
</script>

<style lang="scss" scoped>
.main {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  margin-right: 0.75rem;
  width: 1076px;
}
.main .scroll-nav {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  margin-right: 0.75rem;
}
.main .scroll-nav-item {
  border-style: solid;
  border-width: 1px;
  font-weight: 400;
  height: 35px;
  margin-bottom: 1rem;
  text-align: center;
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
  width: 80px;
  border-color: #d3dce7;
  border-radius: 2px;
  font-size: 15px;
  line-height: 35px;
}
.main .scroll-nav .is-active {
  --tw-bg-opacity: 1;
  background-color: rgba(242, 91, 59, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  border-color: #f25b3b;
}
.brand-content {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  min-height: 1200px;
  padding: 1.5rem;
  width: 986px;
  background: #fff url("@/assets/img/company/brand/brand-content_bg.png") no-repeat left top;
  background-size: contain;
}
.brand-content .introduction {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  width: 100%;
}
.brand-content .introduction .brand-introduction {
  -ms-flex-item-align: start;
  -webkit-align-self: flex-start;
  align-self: flex-start;
  font-weight: 500;
  font-size: 1.125rem;
  line-height: 1.75rem;
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
  width: 100%;
}
.brand-content .introduction .brand-company__logo {
  height: 44px;
  margin-top: 63px;
  margin-bottom: 20px;
  width: 137px;
}
.brand-content .introduction .brand-company__name {
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
  font-size: 24px;
}
.brand-content .introduction .brand-company__describe {
  font-weight: 600;
  margin-top: 20px;
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
  font-size: 16px;
}
.brand-content__title {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  margin-bottom: 20px;
  width: 100%;
}
.brand-content__title em {
  --tw-bg-opacity: 1;
  background-color: rgba(242, 91, 59, var(--tw-bg-opacity));
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: -webkit-inline-flex;
  display: inline-flex;
  height: 2px;
  margin-right: 0.5rem;
  width: 2px;
  border-radius: 50%;
}
.brand-content__title span {
  font-weight: 500;
  font-size: 14px;
}
.brand-content p {
  font-weight: 400;
  line-height: 30px;
  text-align: justify;
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
  white-space: pre-line;
  font-size: 16px;
}
.brand-content .brand-video, .brand-content .brand-image {
  margin-top: 51px;
  margin-bottom: 51px;
  width: 100%;
}
</style>
